import { StandardEvents } from '@shopify/events';

// The form exists for Awtomic's own widget, never for a direct bundle cart add.
class GgxBabWidgetForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form[data-ggx-bab-widget-form]');
    this.input = this.form?.querySelector('input[name="id"]');
    this.section = this.closest('.shopify-section');
    this.picker = this.section?.querySelector('variant-picker');
    if (!this.form || !this.input || !this.picker || this.picker.dataset.productId !== this.dataset.productId) return;
    this.abort?.abort();
    this.observer?.disconnect();
    this.abort = new AbortController();
    this.generation = (this.generation ?? 0) + 1;
    this.variantIds = new Set((this.dataset.variantIds || '').split(','));
    this.widget = this.section.querySelector(`.awtomic-sw[data-sw-product-id="${this.dataset.productId}"]`);
    this.ready = this.dataset.variantAvailable === 'true';
    const options = { signal: this.abort.signal };
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
    }, { ...options, capture: true });
    this.form.addEventListener('click', (event) => {
      if (!event.target.closest('#awtomic-sw__customize-box-btn')) return;
      if (!this.canNavigate()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, { ...options, capture: true });
    const guardFallback = (event) => {
      if (event.target.closest('[data-ggx-builder-route]') && new URLSearchParams(location.search).has('selling_plan')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };
    for (const type of ['click', 'auxclick', 'contextmenu']) this.addEventListener(type, guardFallback, { ...options, capture: true });
    this.section.addEventListener(StandardEvents.productSelect, this.onSelect, options);
    this.observer = new MutationObserver(() => this.syncButton());
    this.observer.observe(this.form, { childList: true, subtree: true });
    this.syncButton();
  }

  disconnectedCallback() {
    this.abort?.abort();
    this.observer?.disconnect();
    this.generation++;
  }

  canNavigate() {
    const state = this.picker?.dataset.selectionState;
    const params = new URLSearchParams(location.search);
    const urlVariant = params.get('variant');
    return this.ready && state !== 'loading' && state !== 'error' && this.variantIds.has(this.input.value) && !params.has('option_values') && (!urlVariant || urlVariant === this.input.value);
  }

  syncButton() {
    this.widget = this.section.querySelector(`.awtomic-sw[data-sw-product-id="${this.dataset.productId}"]`);
    const native = this.form.querySelector('button[type="submit"]');
    if (native) native.disabled = true;
    const button = this.form.querySelector('button#awtomic-sw__customize-box-btn.awtomic-sw__customize-btn[type="button"]');
    this.toggleAttribute('data-widget-ready', Boolean(button));
    this.toggleAttribute('data-plan-pending', new URLSearchParams(location.search).has('selling_plan'));
    if (this.widget) this.widget.inert = !button || !this.canNavigate();
    if (button) button.disabled = !this.canNavigate();
  }

  onSelect = async (event) => {
    if (event.target !== this.picker || event.target.dataset.productId !== this.dataset.productId) return;
    const generation = ++this.generation;
    this.ready = false;
    this.syncButton();
    try {
      const { detail } = await event.promise;
      if (!this.isConnected || generation !== this.generation) return;
      const resource = detail?.resource;
      if (String(detail?.productId) !== this.dataset.productId || !this.variantIds.has(String(resource?.id)) || resource.available !== true) return;
      this.input.value = String(resource.id);
      // Current Awtomic widget observes this standard form attribute itself.
      this.input.setAttribute('value', String(resource.id));
      this.ready = true;
    } catch {
      // Failed or superseded selections remain closed until a valid selection.
    } finally {
      if (this.isConnected && generation === this.generation) this.syncButton();
    }
  };
}
if (!customElements.get('ggx-bab-widget-form')) customElements.define('ggx-bab-widget-form', GgxBabWidgetForm);
